import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { VisitTracker } from './VisitTracker';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <div>
        <VisitTracker />
        <NavMenu />
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
